export default "__VITE_ASSET__668acc37__"